/** Blockfrost mainnet の唯一の接続先。 */
export const blockfrostMainnetOrigin = 'https://cardano-mainnet.blockfrost.io'

/**
 * Secret を付与できる mainnet の GET URL を厳格に検証する。
 * @param params.url クライアントから渡された絶対 URL
 * @returns 正確な origin、許可されたパス・クエリのみを持つ場合 true
 */
export const isAllowedBlockfrostUrl = (params: { url: string }): boolean => {
  let url: URL
  try {
    url = new URL(params.url)
  } catch {
    return false
  }
  if (
    url.origin !== blockfrostMainnetOrigin ||
    url.username !== '' ||
    url.password !== '' ||
    url.hash !== '' ||
    // URL による dot-segment や escape の正規化前も検査する。
    !params.url.startsWith(`${blockfrostMainnetOrigin}/api/v0/`) ||
    /[%\\]/.test(params.url.split('?')[0] ?? '') ||
    params.url
      .split('?')[0]
      ?.split('/')
      .some((part) => part === '.' || part === '..')
  ) {
    return false
  }

  const path = url.pathname.slice('/api/v0'.length)
  const isList =
    /^\/accounts\/stake1[023456789acdefghjklmnpqrstuvwxyz]{53}\/(addresses|transactions|rewards|withdrawals|registrations)$/.test(
      path,
    ) ||
    /^\/addresses\/addr1(?:[023456789acdefghjklmnpqrstuvwxyz]{53}|[023456789acdefghjklmnpqrstuvwxyz]{98})\/transactions$/.test(
      path,
    ) ||
    /^\/txs\/[0-9a-f]{64}\/(stakes|withdrawals)$/.test(path)
  const isDetail =
    /^\/txs\/[0-9a-f]{64}(\/utxos)?$/.test(path) ||
    /^\/epochs\/([0-9]+|latest)(\/parameters)?$/.test(path) ||
    /^\/assets\/[0-9a-f]{56}([0-9a-f]{2}){0,32}$/.test(path)
  if (!isList && !isDetail) return false

  const seen = new Set<string>()
  for (const [key, value] of url.searchParams) {
    if (seen.has(key) || !isList) return false
    seen.add(key)
    if (key === 'page') {
      if (
        !/^[1-9][0-9]*$/.test(value) ||
        !Number.isSafeInteger(Number(value))
      ) {
        return false
      }
    } else if (key === 'count') {
      if (!/^[1-9][0-9]*$/.test(value) || Number(value) > 100) return false
    } else if (key === 'order') {
      if (value !== 'asc' && value !== 'desc') return false
    } else {
      return false
    }
  }
  return true
}
